namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_code_bench_result, {
		
		margin: {
			left: '-0.25rem',
		},

		align: {
			items: 'self-start',
		},

		Copy: {
			pointerEvents: 'auto'
		},
		
		Result: {
			Expand: {
				pointerEvents: 'auto'
			},
			userSelect: 'text',
		},

		Error: {
			// color: '#b00020',
			userSelect: 'text',
		},

		
	} )
	
}
